<template>
  <div :class="['UIToast', `UIToast__${position}`]">
    <TransitionGroup name="UIToast__item">
      <UIAlert
        v-for="toast in toastStore.toasts"
        :key="toast.id"
        :status="toast.type"
        variant="subtle"
        :title="toast.title"
        :description="toast.message"
        @close="() => toastStore.removeToast(toast.id)"
      />
    </TransitionGroup>
  </div>
</template>

<script lang="ts" setup>
import UIAlert from '../alerts/UIAlert.vue'
import { useToast } from '@/store/toast'
import { PropType } from 'vue'
import { TOAST_POSITION } from './types'

const toastStore = useToast()

defineProps({
  position: {
    type: String as PropType<TOAST_POSITION>,
    default: TOAST_POSITION.TOP_RIGHT,
  },
})
</script>

<style lang="scss" scoped>
.UIToast {
  z-index: 9999;
  position: fixed;
  padding: 1rem;
  max-width: 27rem;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  pointer-events: none;
  gap: 0.5rem;

  .UIAlert {
    box-shadow: 0 3px 12px 1px rgb(43 55 72 / 15%);
  }

  &__item {
    @include trans(0.5s);
    // UIToast item animation
    &-move,
    &-enter-active,
    &-leave-active {
      transition: all 0.5s ease;
    }
    &-enter-from,
    &-leave-to {
      opacity: 0;
      transform: translateX(2rem);
    }
    &-leave-active {
      position: absolute;
    }
  }

  &__top-right {
    top: 0rem;
    right: 0rem;
  }

  &__top-left {
    top: 0rem;
    left: 0rem;
  }

  &__bottom-left {
    bottom: 0rem;
    left: 0rem;
  }

  &__bottom-right {
    bottom: 0rem;
    left: 0rem;
  }
}
</style>
